import { render } from "./ActLink.vue?vue&type=template&id=3844445a"
import script from "./ActLink.vue?vue&type=script&lang=js"
export * from "./ActLink.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__